<div class="in-house-maintenance-container" *transloco="let t; prefix: 'maintenanceCosting'">
  <div class="filter-container d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-2">
      <h3 class="section-title">{{ t('inHouse.title') }}</h3>
    </div>

    <div class="filter-controls d-flex align-items-center gap-2">
      <div class="search-wrapper">
        <app-search
          [placeholder]="t('inHouse.searchPlaceholder')"
          [disabled]="isLoading"
          (searchTermUpdated)="onSearchTermUpdate($event)"
          [searchTerm]="searchTerm"
          [customWidth]="'385px'">
        </app-search>
      </div>
    </div>
  </div>

  <div class="table-container">
    <div class="table-inner">
      <div class="table-frame" [style.--visible-rows]="pageSize">
        <table class="contracts-table">
          <thead>
            <tr>
              <th class="asset">{{ t('inHouse.table.asset') }}</th>
              <th class="cost-ytd">{{ t('inHouse.table.costYtd') }}</th>
              <th class="cost-per-km">{{ t('inHouse.table.costPerKm') }}</th>
              <th class="total-cost">{{ t('inHouse.table.totalCostOfOwnership') }}</th>
              <th class="downtime-cost">{{ t('inHouse.table.downtimeCost') }}</th>
              <th class="last-service">{{ t('inHouse.table.lastServiceCost') }}</th>
              <th class="next-service">{{ t('inHouse.table.nextServiceCostEst') }}</th>
            </tr>
          </thead>
          <tbody>
            @if(isLoading) {
              <tr>
                <td colspan="7" class="loading-cell">
                  <div class="spinner-wrapper">
                    <div class="spinner-border"></div>
                  </div>
                </td>
              </tr>
            } @else {
              @if(!costs.length) {
                <tr>
                  <td colspan="7" class="empty-cell">
                    <app-empty-state></app-empty-state>
                  </td>
                </tr>
              }
              @for(cost of costs; track $index) {
                <tr class="contract-row">
                  <td class="asset" [title]="cost.assetName">{{ cost.assetName }}</td>
                  <td class="cost-ytd">{{ formatCurrency(cost.costYTD) }}</td>
                  <td class="cost-per-km">{{ formatCostPerKm(cost.costPerKm) }}</td>
                  <td class="total-cost">{{ formatCurrency(cost.totalCostOfOwnership) }}</td>
                  <td class="downtime-cost">{{ formatCurrency(cost.downTimeCost) }}</td>
                  <td class="last-service">{{ formatCurrency(cost.lastServiceCost) }}</td>
                  <td class="next-service">{{ formatCurrency(cost.nextServiceCostEst) }}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="table-footer d-flex justify-content-between align-items-center">
      @if(!isFullView && totalCount > previewPageSize) {
        <button class="btn view-all-btn" [disabled]="isLoading" (click)="onViewAll()">
          {{ t('shared.viewAll') }}
        </button>
      } @else if(isFullView) {
        <p class="pagination-text">
          {{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}
        </p>
      } @else {
        <div></div>
      }

      @if(isFullView) {
        <app-pagination
          [totalPages]="totalPages"
          [currentPage]="page"
          (pageChange)="goToPage($event)">
        </app-pagination>
      }

      <div></div>
    </div>
  </div>
</div>